import {
    CREATE_PROPERTY,
    CREATE_PROPERTY_FAILURE,

    CREATE_PROPERTY_LOCALISATION,
    CREATE_PROPERTY_LOCALISATION_FAILURE,
    CREATE_PROPERTY_LOCALISATION_SUCCESS,
} from 'store/actions/types';

// Create property
export const createProperty = (payload) => {
    return {
        type: CREATE_PROPERTY,
        payload: payload,
    };
};

export const createPropertyFailure = (error) => {
    return {
        type: CREATE_PROPERTY_FAILURE,
        error: error,
    };
};

// Create property localisation
export const createPropertyLocalisation = (payload, response) => {
    return {
        type: CREATE_PROPERTY_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const createPropertyLocalisationFailure = (error) => {
    return {
        type: CREATE_PROPERTY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const createPropertyLocalisationSuccess = (payload, response) => {
    return {
        type: CREATE_PROPERTY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/properties/createProperties.js